import {
	postApi,
	getApi,
  postApiCapsRabbitmq,
  postApiCapsTunnelDevApi,
  getApiCapsTunnelDevApi
} from "./axios.js"

// 登录接口
export const login = (params) => {
  return postApi('/largeScreen/login',params)
}

// 项目概况
export const projectOverview = (params) => {
  return postApi('/largeScreen/projectOverview',params)
}

// 首页-气体数据
export const gasData = (params) => {
  return postApi('/largeScreen/gasData',params)
}

// 首页-隧道基础数据
export const tunnelData = (params) => {
  return postApi('/largeScreen/tunnelData',params)
}

// 首页-隧道列表数据
export const tunnelDataList = (params) => {
  return postApi('/largeScreen/tunnelDataList',params)
}
// 首页-人机管理数据
export const humanMachine = (params) => {
  return postApi('/largeScreen/humanMachine',params)
}

// 首页-预警公示数据
export const earlyWarningData = (params) => {
  return postApi('/largeScreen/earlyWarningData',params)
}

// 首页-进洞情况数据
export const carSituationData = (params) => {
  return postApi('/largeScreen/carSituationData',params)
}

// 首页-出勤情况数据
export const attendanceData = (params) => {
  return postApi('/largeScreen/attendanceData',params)
}


// 首页-人员门禁数据
export const personnelAttendance = (params) => {
  return postApi('/largeScreen/personnelAttendance',params)
}


// 首页-人员名单
export const personnelList = (params) => {
  return postApi('/largeScreen/personnelList',params)
}


// 首页-人员考勤列表数据
export const personnelAttendanceList = (params) => {
  return postApi('/largeScreen/personnelAttendanceList',params)
}


// 首页-车辆门禁数据
export const carAttendance = (params) => {
  return postApi('/largeScreen/carAttendance',params)
}


// 首页-车辆列表数据
export const carList = (params) => {
  return postApi('/largeScreen/carList',params)
}


// 首页-车辆考勤数据
export const carAttendanceList = (params) => {
  return postApi('/largeScreen/carAttendanceList',params)
}

// 首页-气体数据
export const gasAttendance = (params) => {
  return postApi('/largeScreen/gasAttendance',params)
}


// 首页-气体数据
export const gasDayStatistics = (params) => {
  return postApi('/largeScreen/gasDayStatistics',params)
}


// 首页-洞内人员列表
export const personInTunnel = (params) => {
  return postApi('/largeScreen/personInTunnel',params)
}

// 首页-当天洞内人员列表
export const personInTunnelToday = (params) => {
  return postApi('/largeScreen/personInTunnelToday',params)
}

// 首页-隧道进度表
export const tunnelProgress = (params) => {
  return postApi('/largeScreen/tunnelProgress',params)
}

// 首页-各类预警信息 “type”: “gas” // 类型   gas：环境预警  personnel：人员预警 car：车辆预警  pace：步距预警  
export const warningList = (params) => {
  return postApi('/largeScreen/warningList',params)
}

// 安全步距
export const getTunnelStepData = (params) => {
  return postApi('/largeScreen/getTunnelStepData',params)
}


// 首页-党建活动
export const partyBuilding = (params) => {
  return postApi('/largeScreen/partyBuilding',params)
}

// 首页-风险管理
export const riskInvestigation = (params) => {
  return postApi('/largeScreen/riskInvestigation',params)
}

// 首页-方案交底
export const schemeDisclosure = (params) => {
  return postApi('/largeScreen/schemeDisclosure',params)
}

// 首页-工艺工装
export const processTooling = (params) => {
  return postApi('/largeScreen/processTooling',params)
}

// 首页-视频监控
export const videoMonitoring = (params) => {
  return postApi('/largeScreen/videoMonitoring',params)
}

// 首页-获取分类树接口
export const typeTree = (params) => {
  return postApi('/largeScreen/typeTree',params)
}

// 首页-分类ID查询数据
export const getDataByTreeId = (params) => {
  return postApi('/largeScreen/getDataByTreeId',params)
}

// 首页-根据数据ID获取地址
export const getFileUrlById = (params) => {
  return postApi('/largeScreen/getFileUrlById',params)
}

// 首页-七天预警汇总
export const getWarningStatistics = (params) => {
  return postApi('/largeScreen/warningStatistics',params)
}

// 人员管理-统计洞内人员岗位信息
export const getStatisticsOfPersonnelInTunnel = (params) => {
  return postApi('/largeScreen/statisticsOfPersonnelInTunnel',params)
}

// 人员管理-统计当天出勤人员岗位信息
export const getStatisticsOfPersonnelAtt = (params) => {
  return postApi('/largeScreen/statisticsOfPersonnelAtt',params)
}

// 人员管理-人员最近七天出勤数量统计
export const getStatisticsOfPersonnelAttCountWeek = (params) => {
  return postApi('/largeScreen/statisticsOfPersonnelAttCountWeek',params)
}

// 车辆管理-统计洞内车辆信息
export const getStatisticsOfCarInTunnel = (params) => {
  return postApi('/largeScreen/statisticsOfCarInTunnel',params)
}

// 车辆管理-统计当天出勤车辆信息
export const getStatisticsOfCarAtt = (params) => {
  return postApi('/largeScreen/statisticsOfCarAtt',params)
}

// 车辆管理-车辆最近七天出勤数量统计
export const getStatisticsOfCarAttCountWeek = (params) => {
  return postApi('/largeScreen/statisticsOfCarAttCountWeek',params)
}

// 获取省份隧道统计
export const getstatisticsTunnelCount = (params) => {
  return postApi('/largeScreen/statisticsTunnelCount',params)
}

// 所有隧道进度情况
export const getstatisticsTunnelProgress = (params) => {
  return postApi('/largeScreen/statisticsTunnelProgress',params)
}

// 所有隧道7天预警数量统计
export const getstatisticsTunnelWarning = (params) => {
  return postApi('/largeScreen/statisticsTunnelWarning',params)
}

// 隧道人员、车辆、设备数量统计
export const getstatisticsMultipleItemCount = (params) => {
  return postApi('/largeScreen/statisticsMultipleItemCount',params)
}

// 进度申报列表
export const getprogressDeclarationList = (params) => {
  return postApi('/largeScreen/progressDeclarationList',params)
}

// 申请试用新增
export const userRegisterAdd = (params) => {
  return postApi('/system/userRegister/add',params)
}
// 申请试用新增
// export const userRegisterAdd = (params) => {
//   return postApi('/system/user/applyUser',params)
// }

// 申请试用修改
export const userRegisterUpdate = (params) => {
  return postApi('/system/userRegister/update',params)
}

// 申请试用结果
export const userRegisterList = (data) => {
  return getApi('/system/userRegister/list?telephone='+data.telephone+ '&status='+data.status)
}

// 汇总人员统计
export const statisticsOfPersonnelnSite = (params) => {
  return postApi('/largeScreen/statisticsOfPersonnelInSite',params)
}

// 功能菜单
export const projectenus = (params) => {
  return postApi('/largeScreen/projectMenus',params)
}

// 气体设备
export const getGasNetworking = (params) => {
  return postApi('/largeScreen/getGasNetworking',params)
}

// 气体类型
export const getGasType = (params) => {
  return postApi('/largeScreen/getGasType',params)
}


// 修改LED显示内容
export const teamInfoServiceAdd = (params) => {
  return postApiCapsRabbitmq('/teamInfoService/add',params)
}


// 隧道新前置机授权查询
export const sysRegisterList = (params) => {
  return postApiCapsTunnelDevApi('/SysRegister/list',params)
}


// 隧道新前置机授权
export const sysRegisterUpdate = (params) => {
  return postApiCapsTunnelDevApi('/SysRegister/update',params)
}

